import { AxiosRequestConfig } from 'axios';

import api from 'api';

export interface AuthorizedSignatorySchema {
  personsId: number;
  givenName1: string | null;
  surnameFirst: string | null;
  dateOfBirth: string | null;
  nationalityCountryIsocode: string | null;
  idnumber: string | null;
  personDocumentsTypesId: number | null;
  documentsBlobId: string | null;
  blobFileSize: number | null;
  blobFileExtension: string | null;
  blobFileName: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  stateOrProvince: string | null;
  countryIsocode: string | null;
  postalCode: string | null;
  modifiedOn: string | null;
  createdOn: string | null;
}

export const getAuthorizedSignatories = async (
  businessesId: number,
  personsId: number,
) => {
  const signatory: AuthorizedSignatorySchema | null = await api.get(
    `AuthorizedSignatories/GetAuthorizedSignatories/${businessesId}/${personsId}`,
  );

  return signatory;
};

export const saveAuthorizedSignatories = async (
  payload: FormData,
  options = {} as AxiosRequestConfig,
) => {
  const result = await api.post(
    'AuthorizedSignatories/SaveAuthorizedSignatories',
    payload,
    options,
  );

  return result;
};

export const getAuthorizedSignatoriesFile = async (
  businessesId: number,
  guid: string,
) => {
  const file: Blob = await api.get(
    `AuthorizedSignatories/GetAuthorizedSignatoriesFile/${businessesId}/${guid}`,
    {
      responseType: 'blob',
    },
  );

  return file;
};
